import React from "react"
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { Form, Error, UnexpectedError } from "./components/screens";
import './App.css';

import {
    AuthProvider,
    PrivateRoute,
    Callback,
    SilentRenew,
    Logout
} from './components/auth'

import ErrorBoundary from './components/Errors/ErrorBoundary';
import settingsService from './services/settingsService';

const App = () => {
    const protectedRoutes = [
        { path: "/", component: () => Form() }
    ]

    const createProtectedRoutes = () => {
        return protectedRoutes.map((protectedRoute, index) => {
            return <PrivateRoute key={index} exact path={protectedRoute.path} component={protectedRoute.component} />
        })
    }

    return (
        <div className="container">
            <div className="App">
                <ErrorBoundary>
                    <AuthProvider config={settingsService.authConfig}>
                        <Router basename={process.env.PUBLIC_URL}>
                            <Switch>
                                {createProtectedRoutes()}
                                <Route exact path="/signin-oidc" component={Callback} />
                                <Route exact path="/renew-oidc" component={SilentRenew} />
                                <Route exact path="/logout" component={Logout} />
                                <Route exact path="/error/unexpected-error" component={UnexpectedError} />
                                <Route component={Error} />
                            </Switch>
                        </Router>
                    </AuthProvider>
                </ErrorBoundary>
            </div>
        </div>
    );
};

export default App;
